<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div :class="{ 'modal-container  small': !large, 'modal-container large': large  }">

          <div class="modal-body">
            <slot name="body">

              

              <spinner
                v-if="working"
                :size="spinner_size"
                :line-size="spinner_line_size"
                :speed="spinner_speed"
                :spacing="spinner_spacing"
                :message="spinner_message"
                :font-size="spinner_font_size"
                >
              </spinner>

              <h1 v-if="!working && !errorOcurred">Finalizado <i class="material-icons">done</i> </h1>
              <h1 v-if="!working && errorOcurred">Ocurrio un error <i class="material-icons">error_outline</i> </h1>

              <div v-if="!working && errorOcurred" class="row">
                <div class="col-md-12">
                  <span class="form-group__message help is-danger" v-if="error != null">
                    {{error}}
                  </span>
                </div>
              </div>

            </slot>
          </div>

          <div v-if="!working" class="modal-footer">
            <slot name="footer">
              <div class="btn-group" role="group" aria-label="Basic example">
                <button type="button" class="spacedBtn btn btn-primary" @click="closeModal">Cerrar</button>
              </div>
            </slot>
          </div>

        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Spinner from 'vue-simple-spinner'

export default {
  components: {
    Spinner
  },

  created () {
    // console.log('Siempre creado')
    // this.executeOperation()
  },

  props: {
    close: null,
    closeFailure: null,
    working: null,
    errorOcurred: null,
    error: null
  },
  data () {
    return {
      large: true,
      spinner_size: 64,
      spinner_line_size: 3,
      spinner_speed: 0.6,
      spinner_spacing: 4,
      spinner_message: "Trabajando",
      spinner_font_size: 13
    }
  },
  methods: {
    closeModal () {
      if (! this.errorOcurred) {
        this.close()
      } else {
        this.closeFailure()
      }
    }
  }
}
</script>

<style scoped>

.spacedBtn {
  margin-left: 10px !important;
}

i {
  font-size: 40px !important;
}
</style>



// WEBPACK FOOTER //
// LoaderModal.vue?657cc84a